import { isMobileBrowser } from '@rover/utilities/device';
import { getRouteURL } from '@rover/utilities/deeplink';

import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';

export default class {
  static closeBanner() {
    $('.js-app-banner').addClass('hidden');
    $('body').removeClass('has-banner');
    $.cookie('appBanner', true, { expires: 90 });
  }

  static isPossibleBanner() {
    if (!$.cookie('appBanner')) {
      return true;
    }
    return false;
  }

  static init() {
    if (
      !isMobileBrowser() ||
      !this.isPossibleBanner() ||
      Rover.utils.isMobileEmbedded() ||
      $('body').hasClass('no-banner') ||
      !Rover.context.supportsMobileApp
    ) {
      return;
    }

    const routeURL = getRouteURL();
    Rover.context.iOSReviewCount = '2,140+ Reviews';
    Rover.context.androidReviewCount = '2,300+ Reviews';

    $('body').addClass('has-banner');
    $('.js-app-banner').removeClass('hidden');
    $('.js-app-install-link').attr('href', routeURL);
    $('.js-close-app-banner').on('click', this.closeBanner);
    if (Rover.utils.isAndroid()) {
      $('.js-review-count').text(Rover.context.androidReviewCount);
    } else {
      $('.js-review-count').text(Rover.context.iOSReviewCount);
    }
  }
}



// WEBPACK FOOTER //
// ./js/AppInstallBanner.js